import { render, staticRenderFns } from "./SectionWrapper.vue?vue&type=template&id=606302df&scoped=true&"
import script from "./SectionWrapper.vue?vue&type=script&lang=js&"
export * from "./SectionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SectionWrapper.vue?vue&type=style&index=0&id=606302df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606302df",
  null
  
)

export default component.exports